import React from "react";
import { Link } from "react-router-dom";

export default function FinalCTA() {
  return (
    <section
      id="cta"
      className="mx-auto grid max-w-[1200px] grid-cols-1 gap-8 px-6 pb-28 lg:px-10 min-[900px]:grid-cols-[minmax(0,1.2fr)_minmax(0,1fr)]"
    >
      {/* For companies */}
      <div className="flex min-w-0 flex-col items-start gap-5 rounded-[32px] border-[1.5px] border-ink-v2 bg-coral-500 px-12 py-14 shadow-pop-lg">
        <div className="text-[12px] font-bold uppercase leading-none tracking-[0.12em] text-white/85">
          For companies
        </div>
        <h2 className="text-balance text-[44px] font-extrabold leading-[1.02] tracking-[-0.03em] text-white">
          Tell us the job. We&rsquo;ll bring the humans.
        </h2>
        <p className="text-[20px] font-medium leading-[1.5] text-white/90">
          A 15-minute call is all it takes to scope your first engagement.
        </p>
        <Link
          to="/post-job"
          className="mt-2 rounded-full bg-ink-v2 px-8 py-[18px] text-[16px] font-bold leading-none text-white transition-colors duration-120 hover:bg-white hover:text-ink-v2"
        >
          Post a job &rarr;
        </Link>
      </div>

      {/* For freelancers */}
      <div
        id="join"
        className="flex min-w-0 flex-col items-start gap-5 rounded-[32px] border-[1.5px] border-ink-v2 bg-lime-300 px-12 py-14 shadow-pop-lg"
      >
        <div className="text-[12px] font-bold uppercase leading-none tracking-[0.12em] text-ink-v2/70">
          For freelancers
        </div>
        <h2 className="text-balance text-[44px] font-extrabold leading-[1.02] tracking-[-0.03em] text-ink-v2">
          Good at what you do? Prove it.
        </h2>
        <p className="text-[20px] font-medium leading-[1.5] text-ink-v2/80">
          Join the top 5%. Better clients, fair rates, zero chasing invoices.
        </p>
        <Link
          to="/for-freelancers"
          className="mt-2 rounded-full bg-ink-v2 px-8 py-[18px] text-[16px] font-bold leading-none text-white transition-colors duration-120 hover:bg-white hover:text-ink-v2"
        >
          Sign up as talent &#8599;
        </Link>
      </div>
    </section>
  );
}
